import React, { useReducer } from 'react'
import ArtistContext from './artistContext'
import ArtistReducer from './artistReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'
import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_LIVE_LISTING_COUNT,
    GET_ARTIST,
    GET_PAST_LISTING_COUNT,
    GET_ALL_ARTIST,
    GET_ARTIST_NEWS,
    CLEAR_ARTIST_NEWS,
    GET_ARTIST_METRIC_HISTORY,
} from './artistTypes'

const ArtistState = (props) => {
    const initialState = {
        responseStatus: null,
        live_listing: [],
        artist_detail: {},
        past_listing: [],
        all_artists: [],
        artistNews: [],
        metricHistory: [],
    }

    const [state, dispatch] = useReducer(ArtistReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getLiveListingCount = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getLiveListingCount', formData, '', 'product/artist'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_LIVE_LISTING_COUNT,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getPastListingCount = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getPastListingCount', formData, '', 'product/artist'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_PAST_LISTING_COUNT,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getArtist = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'search', formData, '', 'product/artist'),
            ])
            const from = fromVariable ? fromVariable : 'single_artist'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ARTIST,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllArtist = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllArtists', formData, '', 'product/artist'),
            ])
            const from = fromVariable ? fromVariable : 'all_artist'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_ARTIST,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getArtistNews = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getArtistNews', formData, '', 'chartmetric'),
            ])
            const from = fromVariable ? fromVariable : 'artist_news'

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ARTIST_NEWS,
                    payload: res?.data?.data?.responseData?.records?.obj,
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    const clearArtistNewsResponse = () =>
        dispatch({
            type: CLEAR_ARTIST_NEWS,
        })

    const getArtistMetricHistory = async (formData) => {
        const from = 'getArtistMetricHistory'
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getArtistHistoricalMetrics', formData, '', 'chartmetric'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ARTIST_METRIC_HISTORY,
                    payload: res.data.data.responseData,
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    return (
        <ArtistContext.Provider
            value={{
                live_listing: state.live_listing,
                artist_detail: state.artist_detail,
                responseStatus: state.responseStatus,
                past_listing: state.past_listing,
                all_artists: state.all_artists,
                artistNews: state.artistNews,
                metricHistory: state.metricHistory,
                getLiveListingCount,
                getArtist,
                getPastListingCount,
                clearResponse,
                getAllArtist,
                getArtistNews,
                clearArtistNewsResponse,
                getArtistMetricHistory,
            }}
        >
            {props.children}
        </ArtistContext.Provider>
    )
}

export default ArtistState
